
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/pixelaro",
      function () {
        return require("private-next-pages/projects/pixelaro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/pixelaro"])
      });
    }
  